import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { navigate } from 'gatsby';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import Query from '@queries/customer-stories/Features';

import Button from '@common/Button';
import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import RichText from '@common/RichText';
import Col from '@common/Col';
import ImageColourOverlay from '@common/ImageColourOverlay';

import Video from '@common/blocks/flex/Video';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import * as styles from '@common/blocks/flex/flex.module.scss';

const DropdownSearch = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    showImages,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  const featuresQuery = Query();
  const { register, handleSubmit } = useForm();
  const [featureFilter, setFeatureFilter] = useState(['']);
  const createFilterList = (list, key) => {
    const newList = []
    for (let i = 0; i < list?.length; i++) {
      const node = list[i]?.node.customer;
      if (Array.isArray(node[key])) {
        for (let j = 0; j < node[key]?.length; j++) {
          if (newList.findIndex(x => x === node[key][j]) === -1 && node[key][j] != null) {
            if (node[key][j] !== 'Physical Curriculum' && node[key][j] !== 'Digital Curriculum' && node[key][j] !== 'Activity Planning') {
              newList.push(node[key][j]);
            }
            if ((node[key][j] === 'Physical Curriculum' || node[key][j] === 'Digital Curriculum' || node[key][j] === 'Activity Planning') && newList.findIndex(x => x === 'Curriculum') === -1) {
              newList.push('Curriculum');
            }
          }
        }
      }
      else if (newList.findIndex(x => x === node[key]) === -1 && node[key] != null) {
        newList.push(node[key]);
      }
    }
    return newList.sort(function(a, b) {
      return parseInt(a?.split('-')[0]) - parseInt(b?.split('-')[0]);
    });
  }
  const onSubmit = (data) => {
    const params = new URLSearchParams();
    // Convert obj into array
    const query = Object.entries(data);
    // Add in url navigation to filtered page
    query.forEach(x => {
      if (x[1] != ''){
        params.set(x[0], x[1]);
      }
    });
    navigate(`/resources/customer-stories/search?${params.toString()}`);
  };
  useEffect(() => {
    const list = featuresQuery.allContentfulCustomerStory.edges;
    const newFeatureList = createFilterList(list, 'features');
    setFeatureFilter(newFeatureList);
  }, [featuresQuery]);
  return (
    <Section style={{ marginTop: `calc(${imageNegativeMargin} + 50px)` }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour} rounded`]: bgColour,
        'py-5': bgColour && !bgNoPadding,
        'py-3 py-lg-0': bgNoPadding,
        'container card': !bgFullwidth,
        [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <Row className={clsx(`d-flex flex-column align-items-center`, {
            'flex-md-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
            'flex-md-row': imagePosition === 'Right' && !imagePositionTopLg,
            'flex-column-reverse': imagePositionTop || imagePositionTopLg,
            'justify-content-center': !images && textAlignment === 'Center'
          })}>
          {(text || buttons) &&
            <div className={clsx('col', {
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
                'text-start': textAlignment === 'Left',
              })}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='my-3'
                  h2='my-3'
                  ul={listClass}
                  p='mb-3'
                  li='py-2'
                  a='fs-16'
                />
              }
              <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Form.Group as={Row} controlId='features' className='mx-0 mb-3'>
                  <Form.Label column className='fs-20 px-0 mb-3 me-2' xs={'auto'}>{'I need help with:'}</Form.Label>
                  <Col sm={7} className='p-0'>
                    <Form.Select
                      name='features'
                      className='bg-white mb-3'
                      {...register('features')}
                    >
                      <option value=''></option>
                      {featureFilter.map((feature, i) => (
                        <option value={feature} key={i}>{feature}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  {buttons[0] &&
                    <div className='p-0'>
                      <Button
                        variant={buttons[0].variant}
                        size={buttons[0].size}
                        addClass={clsx(`shadow mb-2`, buttons[0].addClass)}
                        copy={buttons[0].copy}
                        style={{whiteSpace:'nowrap'}}
                      />
                    </div>
                  }
                </Form.Group>
              </Form>
            </div>
          }
          {images &&
            <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx('col', imageWidth, {
                [`d-none ${showImages}`]: showImages,
                'mb-3 mb-md-0': imagePositionTop,
                'mb-lg-5': imagePositionTopLg,
                [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
              })}>
              {images.map(image => (
                <Img
                  key={image.id}
                  loading='eager'
                  image={image.gatsbyImageData}
                  file={image.file}
                  alt={image.description}
                  style={{ maxHeight: imageMaxHeight }}
                  imgStyle={{ objectFit: imageMaxHeight ? 'contain' : ''}}
                />  
              ))}
            </div>
          }
          {links &&
            <div className={clsx('col', imageWidth, {
                [`d-none ${showImages}`]: showImages,
                'mb-3 mb-md-0': imagePositionTop,
                'mb-lg-5': imagePositionTopLg,
                [styles.removeTopMargin]: imageNegativeMargin && !imagePositionTop
              })}>
              {links.map((link, index) => (
                <ImageColourOverlay key={index} to={link.link} image={link.image} colour={link.backgroundColour}>
                  <div className='text-uppercase text-white' style={{marginBottom:'5px'}}>{link.title}</div>
                  <div className='d-flex align-items-center fs-12 fw-medium text-white'>
                    <span style={{marginRight: '5px'}}>{link.linkCopy}</span>
                    <FontAwesomeIcon icon={faChevronRight} size ='sm'/>
                  </div>
                </ImageColourOverlay>
              ))}
            </div>
          }
        </Row>
      </Container>
    </Section>
  )
}

export default DropdownSearch
